import {
  IdIdentifier,
  TimeIdentifiers,
  UserIdentifier,
} from '../common/identifiers';
import { Ability, Role } from '../admin-role';

export type AdminImpersonation = IdIdentifier &
  TimeIdentifiers &
  UserIdentifier & {
    impersonatedAccountId: string;
    impersonatedUserId: string;
    expiryDate: Date;
    token: string;
  };

export type AdminImpersonationDetails = AdminImpersonation & {
  impersonatedAccess: {
    role: Role;
    abilities: Ability;
  };
};

export const CredentialsImpersonationRoles: Role[] = [
  Role.SuperUser,
  Role.InHouseAgent,
  Role.Admin,
];
